






























import {formatString} from '@/shared/filters/utils-filter';
import {defineComponent} from "@vue/composition-api";
import {useGetters, useState} from "vuex-composition-helpers";

export default defineComponent({
  name: 'Popup',
  props: {
    showActiveFilters: {type: Boolean}
  },
  methods: {
    formatString
  },
  setup: () => {
    const {searchResultsCount} = useState(['searchResultsCount'])
    const {labels} = useGetters(['labels'])

    return {
      searchResultsCount,
      labels
    }
  }
})
